import { EventEmitter, Pipe, PipeTransform } from '@angular/core';
import { Product } from 'ZalamoLibrary/src/lib/ui/orders/graphql';
import { calculateProductPriceFromParams } from 'ZalamoLibrary/src/lib/ui/products/products-front/helpers';
import {
  formatCurrency,
  getCurrencySymbol,
  getLocaleNumberFormat,
  NumberFormatStyle,
} from '@angular/common';
import { LookBookPriceRounding } from '../../../../../photographer-panel/src/graphql';
import { PriceConfig } from '../../../../../photographer-client/src/app/modules/look-book/graphql';

@Pipe({
    name: 'calcPriceForLookBook',
    standalone: false
})
export class CalcPriceForLookBookPipe implements PipeTransform {
  transform(
    productsInPlay: Array<Product>,
    valueMap: Record<string, Record<string, any>>,
    rounding: LookBookPriceRounding = null,
    priceUpdated: EventEmitter<PriceConfig[]>
  ): unknown {
    console.log(productsInPlay, valueMap);
    const prices = productsInPlay
      .map((product) =>
        calculateProductPriceFromParams(
          {
            ...product,
            config:
              typeof product.config === 'string'
                ? JSON.parse(product.config)
                : product.config,
          },
          valueMap[product.productId],
          'PLN'
        )
      )
      .map((price) => {
        switch (rounding) {
          case LookBookPriceRounding.One:
            return Math.ceil(price);

          case LookBookPriceRounding.Five:
            return Math.ceil(price / 5) * 5;

          case LookBookPriceRounding.Ten:
            return Math.ceil(price / 10) * 10;
        }
        return price;
      });
    const format = getLocaleNumberFormat('pl', NumberFormatStyle.Currency);
    priceUpdated.next(prices.map((price) => ({ price, code: 'PLN' })));
    if (prices.length === 1 || prices[0] === prices[1]) {
      return formatCurrency(
        prices[0],
        'pl',
        getCurrencySymbol('PLN', 'narrow')
      );
    } else {
      const current = prices.sort();
      return `${[
        formatCurrency(
          current.shift(),
          'pl',
          getCurrencySymbol('PLN', 'narrow')
        ),
        formatCurrency(current.pop(), 'pl', getCurrencySymbol('PLN', 'narrow')),
      ].join(' - ')}`;
    }
    return null;
  }
}
